// extracted by css-extract-rspack-plugin
export default {"menu":"menu-TDSTVA","action":"action-XFpJco","root":"root-WKa3hy","dropdown":"dropdown-Y1xlsd","arrow":"arrow-EAHZ4O","open":"open-rm2_kM","main":"main-E2Wlov"};